const axios = require("axios");
const { getBaseUrl } = require("./baseUrl");

/* NodeJS */
module.exports = {
  getConfiguration: (propertyUid, language = "en") =>
    getBaseUrl().then((url) =>
      axios({
        method: "GET",
        url: `${url}/configuration?property_uid=${propertyUid}&language=${language}`,
      })
    ),
};